import {SearchkitManager} from 'searchkit';

export const {webshop} = window;

export const searchkit = new SearchkitManager(webshop.url, {
  basicAuth: "webshop:2Q8TFt1JRaS7",
  timeout: webshop.timeout,
});


// WEBPACK FOOTER //
// ./src/webshop.js